__turbopack_context__.v({
  "bookmarkButton": "mobile-nav-bar-module-scss-module__CrLd8a__bookmarkButton",
  "bookmarkButtonActive": "mobile-nav-bar-module-scss-module__CrLd8a__bookmarkButtonActive",
  "group": "mobile-nav-bar-module-scss-module__CrLd8a__group",
  "icon": "mobile-nav-bar-module-scss-module__CrLd8a__icon",
  "item": "mobile-nav-bar-module-scss-module__CrLd8a__item",
  "itemActive": "mobile-nav-bar-module-scss-module__CrLd8a__itemActive",
  "root": "mobile-nav-bar-module-scss-module__CrLd8a__root",
});
